import React from 'react';
import { makeStyles } from 'tss-react/mui';
import palette from '@ui/palette';
import Icon from '@ui/Icon';
import Typography from '@ui/Typography';

interface CommentDeletedProps {
  id: string;
  /**
   * 1 based index for aria pos
   */
  index?: number;
}

const CommentDeleted = ({ id, index }: CommentDeletedProps) => {
  const { classes } = useStyles();
  return (
    <div
      id={`wsl-comment-${id}`}
      role="article"
      aria-posinset={index}
      className={classes.container}
    >
      <div aria-label="Comment deleted" className={classes.selectButton}>
        {''}
      </div>
      <div className={classes.commentContainer}>
        <Icon type="trash02" style={{ color: palette.gray_0 }} />
        <Typography variant="pSm" color="primary">
          Comment deleted
        </Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles()(theme => ({
  container: {
    position: 'relative',
    borderRadius: theme.spacing(0.5),
    backgroundColor: palette.gray_1000,
  },
  commentContainer: {
    boxSizing: 'border-box',
    padding: '8px 4px 8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    borderRadius: 4,
  },
  selectButton: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    border: 'unset',
    borderRadius: theme.spacing(0.5),
    padding: 0,
    cursor: 'default !important',
    '&:focus': {
      outline: `1px solid ${palette.gray_400}`,
    },
    '&:focus-visible': {
      outline: `1px solid ${palette.mint_200}`,
    },
  },
}));

export default CommentDeleted;
